export default __webpack_public_path__ + "static/media/Logo-webSite-AD.c1ff20ce.svg";